import React from "react";
import "./ProjectsTableTitleCell.scss";

import { taskAvatarShape } from "src/app/components/Table/Table";
import { ProjectOrTaskName } from "src/app/project/ProjectOrTaskName";

export function ProjectsTableTitleCell({ project }) {
  return (
    <ProjectOrTaskName
      key={project.projectId}
      item={project}
      disableLink={false}
      singleRow={false}
      taskAvatarShape={taskAvatarShape.Square}
    />
  );
}
